import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Checkbox, Spin, } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import { BeeyLocale } from 'libs/locales/locale';
import SpeakerAvatar from 'components/SpeakerAvatarField/SpeakerAvatar';
import { useEffect } from 'react';
import { getFullName } from '../speaker-utils';
import styles from './style.module.less';
const DuplicateSpeakerAlert = ({ duplicateSpeaker, onIndexChange, onEdit, onMergeChange, mergeChecked, language, }) => {
    var _a;
    useEffect(() => {
        onMergeChange(false);
    }, [duplicateSpeaker.state]);
    if (duplicateSpeaker.state === 'idle') {
        return null;
    }
    if (duplicateSpeaker.state === 'loading') {
        return (_jsx(Alert, { className: styles.alert, message: _jsx(Spin, { size: "small" }), type: "info" }));
    }
    if (duplicateSpeaker.state === 'notFound') {
        return (_jsx(Alert, { className: styles.alert, message: _jsx("span", { className: styles.message, children: txt('noDuplicateSpeaker') }), type: "success", showIcon: true }));
    }
    const { data } = duplicateSpeaker;
    if (data === null || data.length === 0) {
        return null;
    }
    const currentItem = data[duplicateSpeaker.selectedIndex];
    const localization = currentItem.similarLocalization;
    const hasSameLocale = language !== undefined && localization === (language === null || language === void 0 ? void 0 : language.code);
    if (!(localization in currentItem.similarSpeaker.localizations)) {
        return null;
    }
    const speakerLocalization = currentItem.similarSpeaker.localizations[localization];
    const speaker = speakerLocalization.nameVariants[speakerLocalization.defaultVariantIndex];
    const fullName = getFullName(speaker.firstName, speaker.lastName);
    const role = speaker.roles[speaker.defaultRoleIndex];
    const country = (_a = BeeyLocale.fromCode(localization)) === null || _a === void 0 ? void 0 : _a.country;
    const message = hasSameLocale ? txt('duplicateSpeaker') : txt('itThisTheSpeaker');
    const description = hasSameLocale ? txt('duplicateSpeakerDescription') : null;
    const showNavigation = data.length > 1;
    const renderAction = () => {
        if (hasSameLocale) {
            return (_jsx(Button, { size: "small", type: "text", onClick: onEdit, children: txt('editVerb') }));
        }
        return (_jsx(Checkbox, { checked: mergeChecked, onChange: (e) => onMergeChange(e.target.checked) }));
    };
    return (_jsx(Alert, { className: styles.alert, message: _jsx("span", { className: styles.message, children: message }), description: (_jsxs("div", { className: styles.description, children: [_jsxs("div", { className: styles.speakerInfo, children: [_jsx(SpeakerAvatar, {}), _jsxs("div", { children: [_jsx("div", { className: styles.speakerName, children: fullName }), _jsxs("div", { children: [role && `${role}, `, country] })] })] }), description !== null && _jsx("div", { children: description }), showNavigation && (_jsxs("div", { className: styles.navigation, children: [_jsx(Button, { size: "small", type: "text", icon: _jsx(LeftOutlined, {}), disabled: duplicateSpeaker.selectedIndex === 0, onClick: () => onIndexChange(duplicateSpeaker.selectedIndex - 1) }), _jsxs("span", { children: [duplicateSpeaker.selectedIndex + 1, ' / ', data.length] }), _jsx(Button, { size: "small", type: "text", icon: _jsx(RightOutlined, {}), disabled: duplicateSpeaker.selectedIndex === data.length - 1, onClick: () => onIndexChange(duplicateSpeaker.selectedIndex + 1) })] }))] })), type: "info", showIcon: true, action: renderAction() }));
};
export default DuplicateSpeakerAlert;
